module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/cart-light-009866466e336ae77c8827e6c5c2ea7d.svg";